// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"511b0e82","389":"8f6d2681","732":"ed52a85f","863":"69bf39dc","977":"51d498e2"}[chunkId] + ".chunk.js";
};